// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

// Vuetify
import { createVuetify } from "vuetify";

import { VCalendar } from "vuetify/labs/VCalendar";

createVuetify({});
export default createVuetify({
  components: {
    VCalendar,
  },
});
